import { Button, Empty } from "antd";
import styles from './EmptyData.module.css'
import React from "react";

type Props = {
    description:String,
    buttonText:any,
    buttonOnClick?:any,
};

const EmptyData = (props: Props) => {
    const {description, buttonText, buttonOnClick} = props;
  return (
    <>
      <Empty
        image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
        imageStyle={{ height: 60 }}
        description={<span>{description}</span>}
      >
        { buttonText && 
        <Button onClick={buttonOnClick} type="primary">{buttonText}</Button>
}
      </Empty>
    </>
  );
};

export default EmptyData;
